<script>
    import { svelteLogo } from '../Svg';

    let windowW, scrollY;
</script>

<svelte:window bind:innerWidth={windowW} bind:scrollY={scrollY} />

<div class="container">
    <div class="content">
        <h2><span class="font-light">About This</span> Project</h2>
        <p>
            This project was made using <a href="https://svelte.dev/" rel="nofollow, noopener" target="_blank">Svelte</a> for studies porpouses.
        </p>
        <p>
            Svelte is a lighweight component framework. Instead of using techniques like virtual DOM diffing, Svelte writes code that surgically updates the DOM when the state of your app changes. Checkout Svelte <a href="https://svelte.dev/blog/svelte-3-rethinking-reactivity" target="_blank">introductory post</a>
        </p>
    </div>
    { #if windowW > 768 }
        <span class="svelte-logo" style="transform: rotate({(scrollY / 5)}deg">
            {@html svelteLogo}
        </span>
    { /if }
</div>

<style lang="less">
    .container {
        position: relative;

        &:after {
            content: '';
            width: 100px;
            height: 5px;
            background: var(--color-gray-100);
            position: absolute;
            bottom: -40px;
            left: 50%;
            margin-left: -50px;
        }
        .content {
            width: 50%;

            p {
                font-size: 18px;
                color: var(--color-gray-300);
            }
            a {
                text-decoration: underline;
            }

            @media screen and (max-width: 768px) {
                width: 100%;
            }
        }
        .svelte-logo {
            width: 300px;
            position: absolute;
            top: -50px;
            right: 0;
            z-index: -1;
        }
    }
</style>